(function () {
  var FORM_ID = 'app-embed-container-1013996';
  var SUBMIT_URL = 'https://forms.shopifyapps.com/api/v2/form_submission';

  var originalFetch = window.fetch.bind(window);
  var escapeBlocked = false;
  var shadowStylesInjected = false;

  function resetSubmitButton() {
    var embed = document.getElementById(FORM_ID);
    if (!embed || !embed.shadowRoot) return;
    var shadow = embed.shadowRoot;
    var submitBtn = shadow.querySelector('button[type="submit"]');
    if (submitBtn) {
      submitBtn.disabled = false;
      submitBtn.setAttribute('aria-disabled', 'false');
      submitBtn.style.opacity = '1';
      submitBtn.style.pointerEvents = 'auto';
      submitBtn.style.cursor = 'pointer';

      var spinner = submitBtn.querySelector('[data-testid="spinner-icon"]');
      if (spinner) spinner.style.display = 'none';

      submitBtn.classList.add('ww-reset');
    }
  }

  function showFormError(message) {
    var embed = document.getElementById(FORM_ID);
    if (!embed || !embed.shadowRoot) return;
    var shadow = embed.shadowRoot;

    var errorEl = shadow.getElementById('ww-email-error');
    if (!errorEl) {
      errorEl = document.createElement('div');
      errorEl.id = 'ww-email-error';
      errorEl.style.cssText = [
        'color:#AF161D',
        'font-size:13px',
        'font-family:Arial,sans-serif',
        'margin:8px 0',
        'padding:8px 12px',
        'background:#fff0f0',
        'border:1px solid #AF161D',
        'border-radius:4px',
        'text-align:left'
      ].join(';');
      var submitBtn = shadow.querySelector('button[type="submit"]');
      if (submitBtn && submitBtn.parentNode) {
        submitBtn.parentNode.insertBefore(errorEl, submitBtn);
      } else {
        shadow.appendChild(errorEl);
      }
    }
    errorEl.textContent = message;
    errorEl.style.display = 'block';

    setTimeout(resetSubmitButton, 50);
  }

  function clearFormError() {
    var embed = document.getElementById(FORM_ID);
    if (!embed || !embed.shadowRoot) return;
    var errorEl = embed.shadowRoot.getElementById('ww-email-error');
    if (errorEl) errorEl.style.display = 'none';
  }

  function watchForSuccess(shadow) {
    var successObserver = new MutationObserver(function () {
      // Look for the success screen — Shopify Forms uses data-testid="success" or a heading with "success" text
      var successEl = shadow.querySelector('[data-testid="success-view"], [data-testid="success"], [class*="_success"]');
      if (!successEl) {
        // Fallback — look for any heading containing success-like text
        var headings = shadow.querySelectorAll('h1, h2, h3, [class*="_heading"]');
        headings.forEach(function (h) {
          if (h.textContent.toLowerCase().includes('success') || h.textContent.toLowerCase().includes('thank you')) {
            successEl = h;
          }
        });
      }
      if (successEl) {
        successObserver.disconnect();
        setTimeout(function () {
          window.location.reload();
        }, 700);
      }
    });

    successObserver.observe(shadow, { childList: true, subtree: true });
  }

  function injectShadowStyles(shadow) {
    if (shadow.getElementById('ww-shadow-styles')) return;

    var style = document.createElement('style');
    style.id = 'ww-shadow-styles';
    style.textContent = [
      /* Hide close button */
      '[aria-label="Close modal"] { display: none !important; }',
      /* Disable clicks on the overlay/backdrop */
      '._overlay_1q1d2_100, ._overlayBackground_1q1d2_123 {',
      '  pointer-events: none !important;',
      '}',
      /* Ensure form container and all children remain clickable */
      '._formContainer_1q1d2_30, ._formContainer_1q1d2_30 * {',
      '  pointer-events: auto !important;',
      '}',
      /* Restore button text when reset */
      'button.ww-reset [class*="_visuallyHidden"] {',
      '  position: static !important;',
      '  width: auto !important;',
      '  height: auto !important;',
      '  overflow: visible !important;',
      '  clip: auto !important;',
      '  clip-path: none !important;',
      '  white-space: normal !important;',
      '  border: 0 !important;',
      '  padding: 0 !important;',
      '  color: inherit !important;',
      '}'
    ].join(' ');

    if (shadow.firstChild) {
      shadow.insertBefore(style, shadow.firstChild);
    } else {
      shadow.appendChild(style);
    }
    shadowStylesInjected = true;
  }

  function blockEscapeKey() {
    if (escapeBlocked) return;
    escapeBlocked = true;
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' || e.key === 'Esc' || e.keyCode === 27) {
        var embed = document.getElementById(FORM_ID);
        if (embed) {
          e.preventDefault();
          e.stopImmediatePropagation();
        }
      }
    }, true);
  }

  function initForm(embed) {
    var shadow = embed.shadowRoot;

    if (shadow) {
      injectShadowStyles(shadow);
      blockEscapeKey();
      watchForSuccess(shadow);

      var shadowObserver = new MutationObserver(function () {
        injectShadowStyles(shadow);
      });
      shadowObserver.observe(shadow, { childList: true, subtree: true });

    } else {
      var shadowCheck = setInterval(function () {
        var s = embed.shadowRoot;
        if (!s) return;
        clearInterval(shadowCheck);
        injectShadowStyles(s);
        blockEscapeKey();
        watchForSuccess(s);

        var shadowObserver = new MutationObserver(function () {
          injectShadowStyles(s);
        });
        shadowObserver.observe(s, { childList: true, subtree: true });
      }, 50);
      setTimeout(function () { clearInterval(shadowCheck); }, 5000);
    }

    var inputCheck = setInterval(function () {
      var s = embed.shadowRoot;
      if (!s) return;
      var emailInput = s.querySelector('input[type="email"], input[name="email"]');
      if (!emailInput) return;
      clearInterval(inputCheck);
      emailInput.addEventListener('input', clearFormError);
    }, 300);
    setTimeout(function () { clearInterval(inputCheck); }, 10000);
  }

  window.fetch = function (input, init) {
    var url = (typeof input === 'string') ? input : (input && input.url ? input.url : '');

    if (url === SUBMIT_URL && init && init.body) {
      try {
        var body = JSON.parse(init.body);
        if (body.form_instance_id == 1013996 && body.email) {
          var enteredEmail = body.email.trim().toLowerCase();
          var customerEmail = (window.WW_CUSTOMER_EMAIL || '').trim().toLowerCase();

          if (!customerEmail) {
            showFormError('You must be logged in to submit this form.');
            return new Promise(function () {});
          }

          if (enteredEmail !== customerEmail) {
            showFormError('Customer not found. Please check the spelling of your email.');
            return new Promise(function () {});
          }

          clearFormError();
        }
      } catch (e) {}
    }

    return originalFetch.apply(window, arguments);
  };

  var observer = new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      mutation.addedNodes.forEach(function (node) {
        if (!node.tagName) return;
        if (node.tagName.toLowerCase() === 'shopify-forms-embed' && node.id === FORM_ID) {
          initForm(node);
        }
      });
    });
  });

  observer.observe(document.documentElement, { childList: true, subtree: true });

  document.addEventListener('DOMContentLoaded', function () {
    var embed = document.getElementById(FORM_ID);
    if (embed) initForm(embed);
  });

})();